import toast from 'react-hot-toast';
import { ApiEndpoints } from '../../services/endpoints';
import { BASE_URL, apiService } from '../../services/service';
import {
    ORDER,
    ORDER_SUCCESS,
    ORDER_FAIL,
    SINGLE_ORDER_SUCCESS,
    SINGLE_ORDER_FAIL,
    INITIATE_PRODUCT_RETURN,
    INITIATE_PRODUCT_RETURN_SUCCESS,
    INITIATE_PRODUCT_RETURN_FAIL,
} from '../actionTypes';

export const fetchOrder = () => async (dispatch) => {
    try {
        dispatch({ type: ORDER });
        const response = await apiService.get(`${BASE_URL}${ApiEndpoints.GET_ORDERS}`);
        dispatch({ type: ORDER_SUCCESS, payload: response.data });
        toast.success('Successful', { position: 'top-right' });
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        dispatch({ type: ORDER_FAIL, error: message });
        toast.error(message, { position: 'top-right' });
    }
};

export const fetchOrderByID = async (id) => {
    try {
        const response = await apiService.get(
            `${BASE_URL}${ApiEndpoints.GET_ORDERS}?order_id=${id}`,
        );
        return response.data;
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        console.log({ error, message });
    }
};

export const fetchSingleOrder = (id) => async (dispatch) => {
    if (!id) return;
    try {
        dispatch({ type: ORDER });
        const response = await apiService.get(
            `${BASE_URL}/requests/zoho/get-orderdetail?order_id=${id}`,
        );
        dispatch({ type: SINGLE_ORDER_SUCCESS, payload: response.data });
        toast.success('Successful', { position: 'top-right' });
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        dispatch({ type: SINGLE_ORDER_FAIL, error: message });
        toast.error(message, { position: 'top-right' });
    }
};

export const initiateProductReturn = (data) => async (dispatch) => {
    try {
        dispatch({ type: INITIATE_PRODUCT_RETURN });
        const response = await apiService.post({
            url: `${BASE_URL}/requests/service/init-order-return`,
            payload: data,
        });
        dispatch(fetchSingleOrder(data.order_id));
        dispatch({ type: INITIATE_PRODUCT_RETURN_SUCCESS, payload: response.data });
    } catch (error) {
        console.log({ error });
        const message = error.response
            ? error.response.data.message
            : error?.message ?? 'Something Went Wrong';
        dispatch({ type: INITIATE_PRODUCT_RETURN_FAIL, error: message });
    }
};
